// PrivateRoute.js
import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { Layout } from "./../LayoutUser/Layout";
import Breadcrumb from "../global/Breadcrumb";
import { FaBan } from "react-icons/fa";
import Alert from "./../global/alert/Alert";

const UserRoute = ({ children }) => {
  const { user } = useSelector((state) => state.authUser);

  const isAuthenticated = Object.keys(user || {}).length === 0;
  const isAttendee = user?.role?.some(
    (role) => role.name === "attendee" || role.name === "organizer"
  );
  const msg = {
    icon: <FaBan className="me-3" />,
    type: "alert-danger",
    text: `Access is denied. You may not have the appropriate permissions to access this resource. You are logged in as: ${
      !isAttendee && "Administrator"
    }`,
  };

  if (isAuthenticated) return <Navigate to="/en/signin" replace />;

  return (
    <>
      {isAttendee ? (
        children
      ) : (
        <Layout>
          <Breadcrumb page="Access denied" />
          <div className="container mt-4" style={{ height: "40vh" }}>
            <Alert {...msg} />
          </div>
        </Layout>
      )}
    </>
  );
};

export default UserRoute;
